import { h } from 'preact';
import Weather from './components/weather';
import definition from './intl.json';
import intl from 'preact-i18n';
// import { SplitPoint } from '@os/split-point';
// import intl, { IntlProvider } from 'preact-i18n';
// import load from 'bundle-loader?lazy&name=widgets/weather-vertical!./components/weather-vertical';
// import createStore from './lib/store';
// import Provider from  'preact-context-provider';
// import { Tabs } from './lib/constants';
// import WeatherMap from './components/map';
// import { WeatherModel } from './model';
// import { DeviceVariance, RenderOnVisible } from '@cube/blocks';

function intlWrap(component) { return intl(component, { scope: 'weather-widget', definition }); }

export const WeatherWidget = intlWrap(Weather);
export default WeatherWidget;
export const WeatherCompact = intlWrap(props => <Weather {...props} compact />);

// weather-vertical-widget

/** Comment out the following until they are used again to reduce bundle and css size

// export const Radar = enhance((props) => (
// 	<div id="radar" style="min-height: 350px;">
// 		<RenderOnVisible>
// 			<DeviceVariance
// 				adaptive
// 				phone={<WeatherMap mapSize="small" />}
// 				other={<WeatherMap mapSize="medium" size="large" />}
// 			/>
// 		</RenderOnVisible>
// 	</div>
// ));

export function UnenhancedWeatherVerticalWidget(props) {
	if (!props.baseURL) {
		props.baseURL = '/weather';
	}
	return (
		<SplitPoint
			{...props}
			load={load}
		/>
	);
}

export const WeatherVerticalWidget = enhance(UnenhancedWeatherVerticalWidget);


function enhance(Child) {
	return class Enhancer extends Component {
		constructor(props, context) {
			super(props, context);
			this.weather = new WeatherModel({
				weatherServiceOrigin: props.weatherServiceOrigin,
				locationServiceOrigin: props.locationServiceOrigin
			});

			this.store = context.store || createStore([], {
				tempUnit: 'f',
				activeTab: Tabs.TODAY
			});

			let state = this.store.getState();
			if (!state || !state.activeTab) {
				this.store.setState({ activeTab: Tabs.TODAY });
			}
		}

		render({ weatherServiceOrigin, locationServiceOrigin, ...props }) {
			return (
				<IntlProvider scope="weather-vertical-widget" definition={definition}>
					<Provider store={this.store} weather={this.weather}>
						<Child {...props} />
					</Provider>
				</IntlProvider>
			);
		}
	};
}

*/



// WEBPACK FOOTER //
// ../node_modules/@cube/weather-widget/src/index.js